import getConversationSortOrderFromSettings from 'mini-mail-load-conversation/lib/utils/getConversationSortOrderFromSettings';
import mailStore from 'owa-mail-store/lib/store/Store';
import { HasLoadState } from 'owa-mail-store/lib/store/schema/ConversationItemParts';

/**
 * Returns true if valid conversation entry exists in the mail store;
 * i.e. valid child nodes, loading state and sort order
 * @param conversationId is the id of the conversation
 */
export default function isValidConversationCache(conversationId: string): boolean {
    const cachedConversation = mailStore.conversations.get(conversationId);
    if (cachedConversation) {
        const conversationSortOrderFromOptions = getConversationSortOrderFromSettings();
        // We don't judge if cache is valid or not based on conversationToLoad.loadingState.isLoading,
        // because even if loading in progress, conversationToLoad still could be a valid cache.
        return (
            cachedConversation.conversationNodeIds.length > 0 &&
            cachedConversation.loadingState.hasLoadState === HasLoadState.hasSucceeded &&
            cachedConversation.conversationSortOrder === conversationSortOrderFromOptions
        );
    }

    return false;
}
